import { Component, Inject, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

import { BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN, IBetslipMessagesProviderService } from '../../base/services/betslip-messages-provider.service';

@Component({
    selector: 'bs-digital-empty-state',
    templateUrl: './betslip-empty-state.component.html',
    styleUrls: ['./betslip-empty-state.component.scss'],
    standalone: false,
})
export class BetslipEmptyStateComponent {
    @Input() inColumn = false;

    readonly messages: {
        betslipEmptyMsg: SafeHtml;
        betslipEmptyHeaderTitle: string;
        noAffiliatePicks: string;
        betslipEmptyNoteMsg: SafeHtml;
        betslipEmptyNoteTitle: SafeHtml;
    };

    module = EpcotModule.Betslip;

    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messagesProvider: IBetslipMessagesProviderService, sanitizer: DomSanitizer) {
        const { common } = messagesProvider.getMessages();
        this.messages = {
            betslipEmptyMsg: sanitizer.bypassSecurityTrustHtml(common.EmptyNote),
            betslipEmptyHeaderTitle: common.EmptyTitle,
            // If betslip is empty after user clicks on affiliate link ( probably old and events are gone ).
            noAffiliatePicks: common.EventExpired,
            betslipEmptyNoteTitle: sanitizer.bypassSecurityTrustHtml(common.EmptyNoteTitle),
            betslipEmptyNoteMsg: sanitizer.bypassSecurityTrustHtml(common.EmptyNoteMessage),
        };
    }
}
